<template>
  <v-app>
    <NavBar v-if="authenticated" :install="installBar" @installApp="installApp"></NavBar>
    <v-content :class="this.$router.currentRoute.name">
      <router-view/>
    </v-content>
    <Snackbar/>
    <v-fade-transition>
      <div class="transitionBG" v-show="transition"></div>
    </v-fade-transition>
    <Bottom v-if="authenticated"></Bottom>
  </v-app>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import Snackbar from '@/components/Snackbar.vue'
import Bottom from '@/components/Bottom.vue'
import { mapGetters, mapActions } from 'vuex' 

let installEvent;

export default {
  name: 'App',
  data: () => ({
    installBar: false
  }),
  components: {
    NavBar,
    Snackbar,
    Bottom
  },
  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      transition: 'menu/transition'
    })
  },
  methods: {
    ...mapActions({
      getData: 'data/getData'
    }),
    getVisited() {
      return localStorage.getItem('install-prompt')
    },
    setVisited() {
      localStorage.setItem('install-prompt', true)
    },
    installApp() {
      this.installBar = false

      // trigger the prompt to show to the user
      installEvent.prompt()

      // check what choice the user made
      installEvent.userChoice.then((choice) => {
        // if the user declined, we don't want to show the button again
        // set localStorage to true
        if (choice.outcome !== 'accepted') {
          this.setVisited()
        }

        installEvent = null
      });
    }
  },
  created() {
    console.log('test')
    if(this.authenticated) {
      this.getData()
    }
  },
  mounted() {
    // this event will only fire if the user does not have the pwa installed
    window.addEventListener('beforeinstallprompt', (event) => {
      event.preventDefault();

      // if no localStorage is set, first time visitor
      if (!this.getVisited()) {
        this.installBar = true
        // store the event for later use
        installEvent = event
      }
    });
  }
};
</script>

<style lang="scss">
@font-face {
  font-family: 'Pyxel';
  src: url('~@/assets/fonts/Pyxel-SemiBold.eot');
  src: url('~@/assets/fonts/Pyxel-SemiBold.eot?#iefix') format('embedded-opentype'),
      url('~@/assets/fonts/Pyxel-SemiBold.woff2') format('woff2'),
      url('~@/assets/fonts/Pyxel-SemiBold.woff') format('woff'),
      url('~@/assets/fonts/Pyxel-SemiBold.ttf') format('truetype'),
      url('~@/assets/fonts/Pyxel-SemiBold.svg#Pyxel-SemiBold') format('svg');
  font-weight: 600;
  font-style: normal;
}
</style>

<style lang="sass">
.theme--light
  .v-content
    background-color: #003a6f
.estimation
    background: #003e72
    color: #fff
    text-align: center
    justify-content: center
    font-size: 20px
    margin: -16px -16px 20px
header
    &.quote-bar
        position: sticky
        top: 0
        z-index: 999
.jobs-count
    font-size: 14px
.filepond--drop-label
    &.filepond--drop-label label
        margin: 0
        color: #fff
        font-size: 20px
        text-transform: uppercase
        font-size: 16px
        line-height: 1em

.filepond--panel-root
    background: #003a6f
    border-radius: 0
    color: #fff!important
    border: 3px dashed #ffffff

.images
    text-align: center

    img 
        padding: 0 4px
        max-width: 100%
</style>